import { Injectable } from '@angular/core';
import { Http, Headers, BaseRequestOptions, RequestOptions, RequestMethod, Jsonp } from '@angular/http';
import { ModalController, ViewController, MenuController, Events, App } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise'
import { Subject } from 'rxjs/Subject'

//Providers
import { ConfigProvider } from '../providers/config-provider';
import { UtilProvider } from '../providers/util-provider';
import { LecturerProvider } from '../providers/lecturer-provider';
import { UserProvider } from '../providers/user-provider';

//Models
import { Url } from '../models/url.model';
import { User } from '../models/user.model';
import { Auth } from '../models/auth.model';
import { UserCookie } from '../models/user-cookie.model';
//import { debounce } from 'ionic-angular/umd/util/util';

@Injectable()
export class AuthProvider {
    public user;
    public headers: Headers;
    public options: RequestOptions;
    public urlAuth = new Url;
    public params = new URLSearchParams();

    public Result: any;

    constructor(public http: Http,
        private jsonp: Jsonp,
        private storage: Storage,
        private modalCtrl: ModalController,
        private menuCtrl: MenuController,
        public events: Events,
        private configProvider: ConfigProvider,
        private utilProvider: UtilProvider,
        private lectureProvider: LecturerProvider,
        private userProvider: UserProvider) {

        this.urlAuth = configProvider.url;
        this.headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': this.urlAuth.SgunAuthorization, 'MobileReferer': this.urlAuth.SgunReferer });
        this.options = new RequestOptions({ headers: this.headers });
        this.params.set('format', 'json');
        this.params.set('callback', this.configProvider.CALLBACK);
    }

    setLoggedUser(user: User) {
        localStorage.setItem('user', user ? JSON.stringify(user) : "");
        this.user = user;
    }

    removeLoggedUser() {
        localStorage.removeItem('user');
        localStorage.removeItem('atividadesAssistidas');
        localStorage.removeItem('atividadesInscritas');
    }

    login(auth: Auth): Promise<User> {
        let body = JSON.stringify(auth);
        let self = this;
        let user: User = null;

        return this.http.post(this.urlAuth.SgunService + '/login-apc/json', body, this.options)
            .map((res: any) => res.json()).toPromise()
            .then(data => {
                if (data != '') {
                    data = JSON.parse(data).resposta;
                    if (data.codigo == 0) {
                        return self.loginp(auth).then(() => {
                            user = data.retorno as User;
                            user.isLogged = true;
                            user.PathFoto = self.utilProvider.checkImage(user.PathFoto, 'USER', false);
                            let nameSplited = user.Nome.split(' ');
                            user.ReducedName = nameSplited[0] + ' ' + nameSplited[nameSplited.length - 1];
                            self.setLoggedUser(user);
                            return user;
                        });
                    }
                }
            });
    }

    loginByAdmin(auth: Auth): Promise<User> {
        let body = JSON.stringify(auth);
        let self = this;
        let user: User = null;

        return this.http.post(this.urlAuth.SgunService + '/login-apc/json', body, this.options)
            .map((res: any) => res.json()).toPromise()
            .then(data => {
                if (data != '') {
                    data = JSON.parse(data).resposta;

                    if (data.codigo == 0) {
                        return self.loginp(auth).then(() => {

                            user = data.retorno as User;
                            user.isLogged = true;
                            user.PathFoto = self.utilProvider.checkImage(user.PathFoto, 'USER', false);
                            let nameSplited = user.Nome.split(' ');
                            user.ReducedName = nameSplited[0] + ' ' + nameSplited[nameSplited.length - 1];
                            self.setLoggedUser(user);
                            return user;
                        });
                    }
                }
            });
    }

    loginp(user: Auth): any {

        let self = this;
        let param = this.params;
        param.set('login', user.UserName);
        param.set('senha', user.Password);

        return this.jsonp.get(this.urlAuth.SgunBase + '/account/handler/loginp.ashx', { search: param })
            .map((res: any) =>
                res.json()
            ).toPromise().then((data) => {
                if (data != '') {
                    data = data.resposta;
                    if (data.codigo == 0) {
                        //TODO: Possiblidade de usar storage
                        Cookie.set('UserSettings', 'sgcookie=' + data.retorno.us_cookie + '&sgguid=' + data.retorno.guid);
                    }
                    return data;
                }
            });
    }

    getUserLogged() {

        let self = this;
        let cookie = Cookie.get('UserSettings');
        if (!cookie) {
            self.removeLoggedUser();
            return new Promise((resolve, reject) => { resolve(null) });
        }

        let userCookie: UserCookie = new UserCookie();
        userCookie.validateApcAccess = true;
        userCookie.us_cookie = cookie.split('&')[0].replace('sgcookie=', '');
        userCookie.guid = cookie.split('&')[1].replace('sgguid=', '');
        let body = JSON.stringify(userCookie);


        return this.http.post(this.urlAuth.SgunService + '/get-user-logged/json', body, this.options)
            .map((res: any) => res.json()).toPromise()
            .then(data => {
                if (data != '') {
                    data = JSON.parse(data).resposta;

                    if (data.codigo == 0) {
                        return data.retorno as User;
                    }
                    else {
                        self.removeLoggedUser();
                    }
                }

                return null;
            });
    }

    isAuthorized(disablePopup?: boolean): boolean {
        if (disablePopup) {
            if (!localStorage.getItem('user')) {
                return false;
            }
        }
        else {
            if (!localStorage.getItem('user')) {
                this.events.publish('user:login');
                return false;
            }
        }

        return true;
    }

    refreshAuth() {
        let user = JSON.parse(localStorage.getItem('user')) as User;
        return user;
    }

}




// WEBPACK FOOTER //
// ./src/providers/auth-provider.ts